// src/event/paths.js
// Firestore path helpers behind the storage-mode switch (migration Stage 3).
// Intentionally duplicated in both repos — keep in sync with guestlist-web.
//
// STORAGE_MODE "root"   -> paths exactly as before the multi-event migration.
// STORAGE_MODE "events" -> paths move under events/{eventId}/...
// The mode stays "root" until the Stage 7 cutover. See MIGRATION_PLAN.md.
//
// Global collections (events, shortLinks, poshEventMap) keep using the plain
// SDK functions on purpose: they are root-level in both modes.

import { collection, doc } from 'firebase/firestore';
import { resolveEventId } from './resolveEventId';

export const STORAGE_MODE = 'events'; // Stage 7 cutover 2026-06-13 (flipped from 'root')

const eventId = resolveEventId(typeof window !== 'undefined' ? window.location.hostname : '');

export function getEventId() {
  return eventId;
}

function prefixed(segments) {
  return STORAGE_MODE === 'events' ? ['events', eventId, ...segments] : segments;
}

export function eventCollection(db, ...segments) {
  return collection(db, ...prefixed(segments));
}

export function eventDoc(db, ...segments) {
  return doc(db, ...prefixed(segments));
}

// For call sites that talk to the Firestore REST API directly and need a
// path string relative to /documents (the 4 REST pages + token helpers).
// Accepts pre-joined strings too: eventRestPath('guestlists/x/freeEntries').
export function eventRestPath(...segments) {
  return prefixed(segments).join('/');
}

// REST :runQuery scopes to the parent in the URL. Root mode queries
// .../documents:runQuery; events mode .../documents/events/{eventId}:runQuery.
export function eventRestQueryParent() {
  return STORAGE_MODE === 'events' ? `/events/${eventId}` : '';
}

// Stage 6: collection-group queries match docs in EVERY tree — the legacy
// root tree and every events/{eventId}/ tree. Between the Stage 5 copy and
// the root-tree retirement both trees hold the same docs, so unfiltered
// collection-group reads return duplicates. Root mode keeps only root-tree
// docs; events mode keeps only the active event's tree.
export function isInActiveEventTree(refPath) {
  return STORAGE_MODE === 'events' ? refPath.startsWith(`events/${eventId}/`) : !refPath.startsWith('events/');
}
